import { memo, useCallback } from "react";
import { TableSearch } from "ui/components/Table/TableSearch";
import { TableGrid } from "ui/components/Table/TableGrid";
import { initialDataWithPagination } from "services/api/consts";
import { useTranslate } from "helpers";
import { FleetVehicleRow } from "services/api/fleet/vehicles/types";
import ListingGridCard from "./components/ListingGridCard";
import { LISTING_VEHICLE_SEARCH_COLUMNS } from "./consts";
import { ListingSearchResultsProps } from "./types";

const ListingSearchResults: React.FC<ListingSearchResultsProps> = (props) => {
  const {
    searchResults,
    listings,
    isLoading,
    viewType = "table",
    selectedRows,
    selectableRows = false,
    onRowClick,
    onPaginationChange,
    onSelectedChange,
    onNewListing,
  } = props;

  const { t } = useTranslate();

  const renderGridItem = useCallback(
    (vehicle: FleetVehicleRow) => {
      const listing = listings.find((l) => l.fleetVehicleId === vehicle.id);
      return <ListingGridCard vehicle={vehicle} listing={listing} onRowClick={onRowClick} />;
    },
    [listings, onRowClick]
  );

  if (viewType === "grid") {
    return (
      <TableGrid
        data={searchResults.data}
        renderItem={renderGridItem}
        pagination={searchResults.pagination || initialDataWithPagination.pagination}
        onPaginationChange={onPaginationChange}
        isLoading={isLoading}
        selectedItems={selectedRows}
        onSelectedChange={onSelectedChange}
        selectableItems={selectableRows}
      />
    );
  }

  return (
    <TableSearch
      columns={LISTING_VEHICLE_SEARCH_COLUMNS(t, listings, onNewListing)}
      data={searchResults.data}
      selectedRows={selectedRows as unknown as number[]}
      selectableRows={selectableRows}
      pagination={searchResults.pagination || initialDataWithPagination.pagination}
      onPaginationChange={onPaginationChange}
      onSelectedChange={onSelectedChange as unknown as ((selected: number[] | number) => void) | undefined}
      isLoading={isLoading}
      onRowClick={onRowClick}
      isMinimized={true}
      size="full"
    />
  );
};

export default memo(ListingSearchResults);
